import React, { useState } from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { FaqItem } from "../faq-item";
import "./faq.m.css";

export const FaqSection = () => {
  const [expandedId, setExpandedId] = useState(1);
  const [showMore, setShowMore] = useState(false);
  const qtConfig = useSelector((state) => get(state, ["qt", "config"]));
  const faqData = get(qtConfig, ["faq", "faq_data"], []);

  const handleToggle = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const visibleFaqs = showMore ? faqData : faqData.slice(0, 4);

  return (
    <section styleName="faq-section" aria-label="Frequently Asked Questions">
      <div styleName="faq-content">
        <div styleName="faq-items">
          <div styleName="faq-title">
            <h1 styleName="faq-heading">Frequently Asked Questions</h1>
            {visibleFaqs.map((faq) => (
              <FaqItem
                key={faq.id}
                id={faq.id}
                title={faq.title}
                content={faq.content}
                isExpanded={expandedId === faq.id}
                setExpandedId={setExpandedId}
                onToggle={() => handleToggle(faq.id)}
              />
            ))}
          </div>
          {faqData.length > 4 ? (
            <button styleName="view-more-button" onClick={() => setShowMore(!showMore)} aria-expanded={showMore}>
              <span styleName="view-more-background">{showMore ? "View Less" : "View More"}</span>
            </button>
          ) : null}
        </div>
      </div>
    </section>
  );
};
